import { taskContract } from "@common/contracts/task.contract";
import { getBackendAPIClient } from "@lib/backendAPIClient";

/** The task API's one ts-rest client, shared by `task.api` and `taskUpdateCache`. */
export const taskClient = getBackendAPIClient(taskContract);
